import { render, staticRenderFns } from "./AssetLoader.vue?vue&type=template&id=a68d4ec0&scoped=true&"
import script from "./AssetLoader.vue?vue&type=script&lang=js&"
export * from "./AssetLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68d4ec0",
  null
  
)

export default component.exports